import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  UseDownloadProps,
  handleExportProps,
} from "./use-downalod-to-csv.types";

export const useDownloadToCsv = ({
  headerCsv,
  exportName,
}: UseDownloadProps) => {
  const handleExport = ({ extension, data }: handleExportProps) => {
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.sheet_add_aoa(ws, [headerCsv]);

    let blob;
    if (extension === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws, { FS: ";" });
      const csvData = "\uFEFF" + csv;
      blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    } else {
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Data");
      blob = XLSX.write(workbook, {
        type: "string",
        bookType: extension === "xlsx" ? "xlsx" : "csv",
      });
    }

    FileSaver.saveAs(blob, `${exportName}.${extension}`);
  };

  return { handleExport };
};
